import React from "react";

function RightSection( {imageURL, productName, productDescription, tryDemo, learnMore, googleplay, appstore}) {
    return (
        <div className="container">
            <div className="row">

                <div className="col-6 p-5 fs-5 mt-5">
                    <h1 className="mt-5 mb-4 pt-5">{productName}</h1>
                    <p className="">{productDescription}</p>
                    <div className="m-3">
                        <b>
                            <a href="{tryDemo}" className="" style={{ marginRight: '10%', textDecoration: "none" }}>Try Demo<i class="fa fa-long-arrow-right" aria-hidden="true"></i></a>
                            <a href="{learnMore}" style={{ marginLeft: "50%", textDecoration: "none" }} className="p-3 m-3">Learn More<i class="fa fa-long-arrow-right" aria-hidden="true"></i></a>
                        </b>
                    </div>
                  


                </div>
                <div className="col-6 pb-5 px-5 py-5">
                    <img src={imageURL} />
                </div>

            </div>
        </div >
    );
}

export default RightSection;